import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=8eaa8004"
import script from "./ProductTemplate.vue?vue&type=script&lang=js"
export * from "./ProductTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProductTemplate.vue?vue&type=style&index=0&id=8eaa8004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports